const BaseView = require('../components/accordion-list/content');
const FormatFactory = require('../../../factory/formats');
const TemplateThumbnailView = require('../components/thumbnail/format');
const AnalyticsDecorate = require('../../../analytics/decorate');

module.exports = AnalyticsDecorate(require('./analytics/sub-categories'), BaseView.extend({
  views: {},
  template: require('./template-content.hbs'),

  TemplatesView: INKIVE.C.BOOK.book_type === INKIVE.C.BOOK_TYPE.DESYGNER_DESIGN
    ? require('./mode-view/designs')
    : require('./mode-view/layouts'),

  events: {
    'click .thumbnail-wrapper .thumbnail': 'thumbnailClickEvent'
  },

  thumbnailClickEvent: function (event) {
    const $thumbnail = $(event.currentTarget);

    return FormatFactory.getFormat($thumbnail.data('key')).then(_.bind(function (format) {
      this.openNewView($thumbnail.data('key'), this.TemplatesView, { format: format });
    }, this));
  },

  initialize: function (options) {
    _.bindAll(this, 'render', 'initScroll', 'thumbnailClickEvent');
    this.tool = INKIVE.Tool.getInstance();
    return FormatFactory.getGroup(options.key).then(this.render);
  },

  render: function (group) {
    this.$el.html(this.template());
    this.appendThumbnails(group.data);

    _.delay(this.initScroll, 1000);
  },

  appendThumbnails: function (data) {
    const padding = 60;
    const width = this.$el.width() - padding;
    const $wrapper = this.$el.find('.thumbnail-wrapper');

    _.each(data, function (format) {
      const $thumbnailView = $('<li>').addClass('thumbnail image loading dark')
        .data('key', format.id)
        .appendTo($wrapper);

      if (format.total_templates - format.total_drafts > 0) {
        new TemplateThumbnailView({
          el: $thumbnailView,
          width: width,
          format: format
        });
      }
    });
  },

  getScrollHeight: function ($target) {
    const headerSize = 100;
    return $target.closest('.tab-content.inner-tabs').height() - headerSize;
  }
}));
